import { createApp } from 'vue'
import { getProductFromHandle } from '~/js/helpers/getProducts'
const CLASS_NAME_COLOR_SELECTOR = 'js-color-selector'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME_COLOR_SELECTOR)
  if (!elements.length) return

  Array.from(elements).forEach(async (element) => {
    const variantHandlesString = element.dataset.variantHandles
    const handle = element.dataset.handleSelected
    const variantHandles = JSON.parse(variantHandlesString)
    if (variantHandles.length > 1) {
      const variants = await Promise.all(
        variantHandles.map(async (variantHandle) => {
          const product = await getProductFromHandle(variantHandle)
          return product && !product.tags.includes('algolia-ignore')
            ? {
                handle: product.handle,
                image: product.images[0],
                title: product.title,
                isSelected: product.handle == handle,
              }
            : null
        })
      )
      const variantsAvailable = variants.filter((v) => v)
      if (variantsAvailable.length > 1) element.style.display = null
      createApp({
        name: 'SnippetsColorSelector',
        data() {
          return {
            variants: variantsAvailable,
          }
        },
      }).mount(element)
    }
  })
})
